<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left" v-if="mode === 'create'">
				{{ $t('promo-to-product.new-promo') }}
			</h4>
			<h4 class="pull-left" v-else>
				{{ $t('promo-to-product.promo') }} - {{ newPromo.name }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
					class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-container fluid id="newPromoId" class="promotion">
				<b-form-group>
					<b-row>
						<b-col cols="3">
							<label :for="department">{{ $t('promo-to-product.department') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col cols="9">
							<b-form-group class="required">
								<multiselect :disabled="mode === 'view'" v-model="newPromo.departmentId"
									:options="listWarehouse" id="department" name="departmentId"
									class="is-invalid required" track-by="id" label="name"
									:placeholder="$t('promo-to-product.department')">
								</multiselect>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.comment">{{ $t('promo-to-product.comment') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-input :disabled="mode === 'view'" size="sm" id="comment" v-model="newPromo.comment"
								name="comment" autocomplete="off" v-validate="validators.comment"
								:placeholder="$t('promo-to-product.comment')" />
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.start">{{ $t('promo-to-product.start-date') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<masked-input :disabled="mode === 'view'" v-model="newPromo.start" mask="11-11-1111"
								name="start" class="form-control form-control-sm" v-validate="validators.start" />
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.finish">{{ $t('promo-to-product.finish-date') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<masked-input :disabled="mode === 'view'" v-model="newPromo.finish" mask="11-11-1111"
								name="finish" class="form-control form-control-sm" v-validate="validators.finish" />
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.name">{{ $t('promo-to-product.name') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-input :disabled="mode === 'view'" size="sm" id="name" v-model="newPromo.name"
								name="name" autocomplete="off" v-validate="validators.name"
								:placeholder="$t('promo-to-product.name')" />
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group v-for="(value, index) in newPromo.promotionXyItems">
					<b-row v-if="index === 1">
						<b-col sm="12">
							<hr>
						</b-col>
					</b-row>
					<b-row class="my-1">
						<b-col sm="3">
							<!-- <label>
								{{ index === 0 ? 'Купить X' : 'Получи Y' }}
								<span class="text-danger">*</span></label> -->
						</b-col>
						<b-col sm="5">
							<label>
								{{ index === 0 ? 'Купить X' : 'Получи Y' }}
								<span class="text-danger">*</span></label>
							<multiselect v-if="mode !== 'view'" v-model="value.itemId"
								:options="index === 0 ? searchItems : searchItems2" :searchable="true"
								:show-labels="false" :internal-search="false" :close-on-select="true" label="name"
								track-by="id" @search-change="index === 0 ? loadItems($event) : loadItems2($event)"
								:placeholder="$t('incomes.create.product')">

								<template slot="singleLabel" slot-scope="props">
									<span v-if="props.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b> - </strong>{{ props.option.barcode }} / {{
											props.option.artikul }} / {{
											props.option.colorName
										}} / {{
											props.option.size
										}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
									<span v-else>
										{{ props.option.artikul }} / {{
											props.option.barcode
										}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
								</template>

								<template slot="option" slot-scope="option">
									<span v-if="option.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b> - </strong>{{ option.option.barcode }} / {{
											option.option.artikul
										}} / {{ option.option.colorName }} / {{
											option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
										<span> /<strong>{{ $t('sale.kol-vo') }}:</strong> {{
											option.option.count1
										}} / <strong>Цена:</strong> </span>
									</span>
									<span v-else>
										{{ option.option.artikul }} / {{
											option.option.barcode
										}} / {{
											option.option.name ? option.option.name.substring(0, 30) : ''
										}} <span> / <strong>{{ $t('sale.kol-vo') }}:</strong> {{
											option.option.count1
										}} / <strong>Цена:</strong> {{ option.option.price }} </span>
									</span>
								</template>
							</multiselect>
							<b-form-input v-else-if="mode === 'view' && value.item" disabled id="name"
								:value="`${value.item.artikul} / ${value.item.barcode} / ${value.item.name}`"
								name="name" autocomplete="off" :placeholder="$t('incomes.create.product')" />
						</b-col>
						<b-col sm="2">
							<div class="d-flex flex-column">
								<label>Старая цена</label>
								<b-form-input v-if="value.itemId && value.itemId.price" disabled id="price"
									:value="value.itemId.price" name="price" autocomplete="off"
									:placeholder="'Старая цена'" />
							</div>
						</b-col>
						<b-col sm="2">
							<label>Цена</label>
							<b-form-input :disabled="mode === 'view'" id="price" v-model="value.price" name="price"
								autocomplete="off" v-validate="validators.price" :placeholder="'Цена'" />
						</b-col>
					</b-row>
				</b-form-group>

				<!-- <b-form-group>
					<hr>
					<b-row class="generalTableClass">
						<b-table show-empty striped hover :items="addItems" :fields="computedFields">
							<template slot="id" slot-scope="data">
								{{ paginate(data.index, searchForm.page, searchForm.limit) }}
							</template>
							<template slot="multiBarcode" slot-scope="data">
								<div v-for="tmp in data.item.multiBarcodes">
									{{ tmp.barcode }}
								</div>
							</template>
							<template slot="artikul" slot-scope="data">
								<div v-for="(tmp, index) in data.item.vendorCodes" :key="`qwe-${index}`">
									{{ tmp.vendor }}
								</div>
							</template>
							<template slot="buyQuantity" slot-scope="data">
								<b-input v-if="mode === 'create'" size="md" id="buyQuantity"
									v-model="data.item.buyQuantity" name="buyQuantity" autocomplete="off"
									:placeholder="$t('Купи Х')" :min="1" type="number" />
								<span v-else>{{ data.item.buyQuantity }}</span>
							</template>
							<template slot="freeQuantity" slot-scope="data">
								<b-input v-if="mode === 'create'" size="md" id="freeQuantity"
									v-model="data.item.freeQuantity" name="freeQuantity" autocomplete="off"
									:placeholder="$t('Получи Y')" :min="1" type="number" />
								<span v-else>{{ data.item.freeQuantity }}</span>
							</template>
							<template slot="empty" slot-scope="scope">
								<span v-if="!selectAll">{{ $t('empty') }}</span>
								<div v-else class="bg-success p-2" style="width:100%;margin:0">
									<span style="font-size:18px">{{
										$t('promo-to-product.selected-all-items')
									}}</span>
								</div>
							</template>
							<template slot="actions" slot-scope="data">
								<div v-if="mode === 'create'">
									<b-link @click="deleteSelectItem(data.index)">
										<i class="fa fa-trash"></i>
									</b-link>
								</div>
							</template>
						</b-table>
					</b-row>
				</b-form-group> -->
			</b-container>
			<div class="modal-actions">
				<b-row class="align-items-center" style="padding-bottom: 10px">
					<b-col cols="6" class="mb-3 mb-xl-0" style="padding-top: 45px;">
						<b-row>
							<b-col cols="5">
								<b-button block size="sm" type="button" @click="cancel" :disabled="loadingForNewPromo"
									variant="outline-danger">{{ $t('cancel') }}</b-button>
							</b-col>
							<b-col cols="5" v-if="mode === 'create'">
								<b-button block type="button" size="sm" @click="create" :disabled="loadingForNewPromo"
									variant="primary">{{ $t('save') }}</b-button>
							</b-col>
							<b-col cols="2">
								<!-- SMALL LOADER -->
								<b-spinner v-if="loadingForNewPromo" small class="ml-2" variant="primary"
									label="Small Spinner"></b-spinner>
								<!-- SMALL LOADER -->
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</form>
	</div>
</template>

<script>
import AddChildren from "./AddChildren";
import { validators } from "../mixins/validators";
import PromoService from "../../../../services/promo.service";
import MaskedInput from 'vue-masked-input'
import WhDocument from '../../../../services/wh-document.service'
import { mapGetters, mapActions, mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
	name: 'NewPromo',
	props: {
		mode: {
			type: String,
			default: 'create'
		},
		edit: {
			type: Object,
			default: null
		},
		totalForEdit: {
			type: Number,
			default: 0
		}
	},
	mixins: [validators],
	data() {
		return {
			selectAll: false,
			searchCollect: {
				plus: [],
				minus: []
			},
			mapIds: {
				plusIds: [],
				minusIds: []
			},
			totalPlus: 0,
			totalMinus: 0,
			searchItems: [],
			searchItems2: [],
			addItems: [],
			selectedDepId: null,
			nvSpiskaDisabledButton: true,
			dobavitDisabledButton: false,
			refreshDisabledButton: true,
			check: false,
			total: 0,
			newMessForSpisok: '',
			whDocument: {},
			responseArray: [],
			department: null,
			createPromo: {
				name: '',
				start: '',
				finish: '',
				comment: '',
				departmentId: null,
				promotionXyItems: [
					{
						itemId: null,
						price: 0,
						isMain: true
					},
					{
						itemId: null,
						price: 0,
						isMain: false
					},
				],
			},
			searchForm: {
				page: 1,
				limit: 20,
			},
			depsArray: [],
			newPromo: null,
			promotionPlusForUpdate: [],
			promotionMinusForUpdate: [],
			childModal: false,
			loadingForNewPromo: false
		}
	},
	methods: {
		...mapActions('promo', ['fetchDepartment', 'searchDoubleDiscountStore']),
		...mapActions('references', ['getReferenceChildren']),
		...mapActions('departments', ['fetchMyDepartments']),

		deleteSelectItem(id) {
			this.addItems.forEach((item, index) => {
				if (index === id) {
					this.addItems.splice(id, 1);
				}
			});
		},
		cancel() {
			this.$emit('close', true);
		},
		dobavitSpisok(newMessSpisok) {
			this.childModal = true;
			this.newMessForSpisok = newMessSpisok;
		},
		newSpisok(newMessSpisok) {
			this.childModal = true;
			this.newMessForSpisok = newMessSpisok;
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		async create() {
			console.log(this.$validator);
			console.log(this.newPromo);

			this.$validator.validate().then(valid => {
				if (valid) {
					let formInput = {
						name: this.newPromo.name,
						start: this.newPromo.start,
						finish: this.newPromo.finish,
						comment: this.newPromo.comment,
						departmentIds: [this.newPromo.departmentId.id],
						promotionXyItems: this.newPromo.promotionXyItems.map(item => {
							return {
								itemId: item.itemId.id,
								price: item.price,
								isMain: item.isMain
							}
						})
					}

					this.loadingForNewPromo = true;
					if (this.mode == 'create') {
						PromoService.addSecondPromo2(formInput).then(res => {
							this.loadingForNewPromo = false;

							this.$emit('success', true);
						}).catch(error => {
							console.log(error);
							this.loadingForNewPromo = false;

							this.$vs.notify({
								text: 'Хатолик йуз берди, яна уриниб коринг',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
						});
					}
					if (this.mode == 'edit') {
						PromoService.updateFinished(formInput).then(response => {
							if (response.data == 'success') {
								this.$emit('success', true);
							}
							this.childModal = false;
						})
					}
				} else {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: 'Заполните все обязательное поле',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			});
			return false;
		},
		async getItem(id) {
			await PromoService.getBuyXGetYPromotionById2(id).then(response => {
				let data = response.data

				this.newPromo.departmentId = data.departmentsList[0]
				this.newPromo.comment = data.comment
				this.newPromo.start = data.start
				this.newPromo.finish = data.finish
				this.newPromo.name = data.name
				this.newPromo.promotionXyItems = data.promotionXyItemDtoList.map(value => ({ ...value, itemId: value }))
			}).catch(error => {
				console.log(error);

				this.loadingForNewPromo = false;

				this.$vs.notify({
					text: 'Хатолик йуз берди, бир оздан сонг яна уриниб коринг',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});

				this.cancel()
			});
		},
		async loadItems($event) {
			await this.getListByProductsNotKirimFunction(this.newPromo.departmentId.id, $event)
		},
		async getListByProductsNotKirimFunction(id, keyword) {
			await WhDocument.getListByProductsNotKirimServiceFunctionNew(id, keyword).then(response => {
				this.searchItems = response.data;
			})
		},
		async loadItems2($event) {
			await this.getListByProductsNotKirimFunction2(this.newPromo.departmentId.id, $event)
		},
		async getListByProductsNotKirimFunction2(id, keyword) {
			await WhDocument.getListByProductsNotKirimServiceFunctionNew(id, keyword).then(response => {
				this.searchItems2 = response.data;
			})
		},
	},
	created() {
		this.fetchMyDepartments();
		this.getReferenceChildren("Promotion_type")
		if (this.mode === 'create') {
			this.newPromo = this.createPromo
		} else {
			this.newPromo = this.createPromo
			this.getItem(this.edit.id)
		}
	},
	computed: {
		listWarehouse() {
			return this.myDepartments.filter(item => {
				return item;
			})
		},
		...mapGetters('promo', {
			'allDeps': 'getDeps'
		}),
		...mapGetters('departments', [
			'myDepartments'
		]),
		...mapState('references', {
			'promoType': 'refPaymentType'
		}),
		...mapState('promo', [
			'searchDoubleDiscount', 'promotionId'
		]),
	},
	watch: {
		'searchForm.page': {
			async handler() {
				let data = {
					plus: this.searchCollect.plus,
					minus: this.searchCollect.minus,
				}
				if (this.mode == 'create') {
					PromoService.savePromotionDoubleArray(data, this.searchForm).then(response => {
						this.newPromo.itemsList = response.data.items
						this.total = response.data.total;
						this.responseArray = response.data;
					});
				}
				if (this.mode == 'edit') {
					if (this.newMessForSpisok !== 'minus' && this.newMessForSpisok !== 'plus') {
						PromoService.simplePromotion(this.promotionId, this.searchForm).then(response => {
							this.newPromo.itemsList = response.data.itemList
							this.totalForEdit = response.data.total;
							this.responseArray = response.data;
						}
						);
					}
					if (this.newMessForSpisok == 'minus') {
						PromoService.updateCollectMinusArray(data, this.searchForm).then(response => {
							this.promotionMinusForUpdate = response.data.items;
							this.mapIds.minusIds = response.data.items[0].itemIds
							this.totalMinus = response.data.total;
							this.childModal = false
						})
					}
				}
			}
		},
		'department': {
			deep: true,
			async handler(value) {
				if (value) {
					this.selectedDepId = value.id
					await this.getListByProductsNotKirimFunction(this.selectedDepId, null);
				} else {
					this.searchItems = []
					this.searchItems2 = []
				}
			}
		},
	},
	components: {
		AddChildren,
		MaskedInput,
		Multiselect
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
#newPromoId {
	.form-group {
		margin-bottom: .5rem;
	}
}

.invalid .multiselect__tags {
	border-color: red;
}

.addItemsModalHeader {
	display: flex;
	width: 100%;
	justify-content: space-between;

	.close {
		font-size: 18px;
	}
}
</style>
